import React, { useState } from 'react';
import { useRecoilValue } from "recoil";

import { emitFindBetByBookId } from "src/services/communicator/actions";
import NumericInput from "src/common/components/numericInput";
import BottomPopover from "src/components/bottomPopover";
import { useOutSideClick } from "src/hooks/outSideClick";
import { useTranslation } from "src/hooks/translation";
import selectionsStore from "src/stores/selections";
import { decimalString } from "src/constants/types";
import { toastWrapper } from 'src/common/components/toastWrapper';

interface IProps {
  isMobile?: boolean;
}

const BookingId = ({ isMobile }: IProps) => {
  const t = useTranslation();
  const { selections } = useRecoilValue(selectionsStore);
  const [bookId, setBookId] = useState<decimalString>("");
  const [isOpen, setIsOpen] = useState(false);
  const outsideRef = useOutSideClick(() => setIsOpen(false), [], '.B-betslip-numeric-keyboard ')

  const findBet = () => {
    if (bookId) {
      emitFindBetByBookId(+bookId);
      setBookId("");
      setIsOpen(false);
    }
  };

  const content = (
    <div className="B-hot-keys-dropdown B-booking-dropdown" ref={outsideRef} onClick={(e) => e.stopPropagation()}>
      <div className="B-hot-keys-dropdown-title">{t('Booking')}</div>
      <NumericInput
        value={bookId}
        maxLength={20}
        onChange={setBookId}
        isMobile={isMobile}
        placeholder="Booking ID"
        className="B-check-input"
      />
      <button className={`B-hot-keys-action-button B-apply ${!bookId ? 'B-disabled' : ''}`} onClick={findBet}>
        {t("Apply")}
      </button>
    </div>
  );

  const handleOpenBookingPopup = () => {
    if (selections.length) return toastWrapper('error', 'There is an unsaved bet in BetSlip. Please cancel or place the bet.')
    setIsOpen(!isOpen)
  }

  if (isMobile) {
    return (
      <>
        <div className="B-hot-keys-wrapper B-hot-keys-trigger" onClick={handleOpenBookingPopup}>
          {t("Booking")}
        </div>
        <BottomPopover
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          rootClassName="B-hot-keys-mobile-popover"
          backdropClassName="B-hot-keys-mobile-backdrop"
          sheetClassName="B-hot-keys-mobile-sheet"
        >
          {content}
        </BottomPopover>
      </>
    );
  }

  return (
    <div className={`B-hot-keys-wrapper B-hot-keys-desktop ${isOpen ? 'opened' : ''}`} onClick={handleOpenBookingPopup}>
      {isOpen && content}
      {t('Booking')}
    </div >)
};

export default BookingId;
